const reativar_matricula = {
  path: "/reativar-matricula",
  redirect: "/reativar-matricula",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção de Matrículas",
  },
  children: [
    {
      path: "/reativar-matricula",
      name: "reativar_matricula",
      component: () =>
        import("@/views/ReativarMatricula/ReativarMatricula.vue"),
    },
  ],
};
export { reativar_matricula };
